<template>
<div class="about_menu_top  textalign_left">    
    <div style="background: #fff;max-width: 1920px;margin: 0 auto;"   class="ms-controller fangyicontain">
        <div style="margin: 0 auto;">
            <div style="height: 7600px;background: url('https://p1.fishqc.net/lgdHm2qHaIp4Y2BKqH1SEG6K5Pu9') center center no-repeat;background-size: auto 100%;padding-top: 408px;box-sizing: border-box;">
                <div style="text-align: center;">
                    <img src="https://p1.fishqc.net/FtYt17Vv7DVL3c3ZJoKJUf0Qe4r4" alt="">
                </div>
                <div class="mumcontain">
                    <div>
                        <div>
                            <div style="margin-top: -90px;">
                                <img src="https://p1.fishqc.net/FlsTtJQskXzCtqjGxA357aXhwTyV" alt="">
                            </div>
                            <div style="margin-top: -26px;">
                                <div class="double11P3_desc1">小仙女们必囤的个人优品肯定是各类护肤用品，贵价精华和日常水乳霜</div>  
                                <div class="double11P3_desc1">也要科学测评才安心。</div>    
                            </div>
                        </div>
                        <div  class="munbox" :style="{marginTop: index1==0?'26px':'24px'}" v-for="(item,index1) in productdata">
                            <div class="producttype">{{item.tap}}</div>
                            <!-- <div class="dec">{{item.dec}}</div> -->

                            <div class="dec-text">{{item.destext}}
                               <!--  <div class="tips">
                                    <div  class="tipstext">{{item.dec}}</div>
                                </div> -->
                            </div>
                            <div>
                                <div class="productdetailcontain" v-for="(val,index) in item.product" @click="toproductdetail(val.type,val.id)">
                                    <div class="flex-container" style="height: 100%">
                                        <div class="imgcontain">
                                            <img :src="val.img" :class="[val.class,'center']">
                                            <img src="https://try.fishqc.com/img/addGreenFish.png"  style="width:65px;" class="greenfish"></img>
                                        </div>
                                        <div class="flex-one" style="text-align: left;position: relative;">
                                            <div class="position_center">
                                                <div class="brandcover">
                                                    <div class="band" v-html="val.brand"></div>
                                                    <div style="height: 26px;" v-if="val.brand == 'FRESH 馥蕾诗'"></div>
                                                </div>
                                                <div class="title">{{val.title}}</div>
                                                <div class="flex-container justify-content_flex-justify align-items_flex-end" style="padding-right: 24px;box-sizing: border-box;">
                                                    <div class="address"  :style="{lineHeight: val.id=='McQ6CJX3p0Cn48EpoJHC6Q'?'40px':'18px'}">品牌所在地：{{val.address}}</div>
                                                    <div class="detail-tips"  v-html="val.tips"></div>
                                                </div>
                                                <!-- padding:val.id=='McQ6CJX3p0Cn48EpoJHC6Q'?'0 4px':'0 12px' -->
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="padding-top: 16px;box-sizing: border-box;">
                        <div>
                            <div class="">
                                <img src="https://p1.fishqc.net/FkZO2i03_ERrYSmXoHA6ulcw1AOU" alt="">

                            </div>
                            <div style="margin-top: -32px;">
                                <div class="double11P3_desc1">家庭日用品消耗量大，更需要在双十一做好一年的囤货安排。科学测评</div>  
                                <div class="double11P3_desc1">的安全优品让你更省心。</div>    
                            </div>
                        </div>
                        <div class="munbox" :style="{marginTop: index2==0?'32px':'25px'}" v-for="(item,index2) in productdata1">
                            <div class="producttype">{{item.tap}}</div>
                            <!-- <div class="dec">{{item.dec}}</div> nJTEcv-p9EwhKu3ctCE3dQ-->

                            <div class="dec-text">{{item.destext}}
                                <!-- <div class="tips">
                                    <div  class="tipstext">{{item.dec}}</div>
                                </div> -->
                            </div>
                            <div>
                                <div class="productdetailcontain" v-for="(val,index) in item.product" @click="toproductdetail(val.type,val.id)">
                                    <div class="flex-container" style="height: 100%">
                                        <div class="imgcontain">
                                            <img :src="val.img" :class="[val.class,'center']">
                                            <img src="https://try.fishqc.com/img/addGreenFish.png"  style="width:65px;" class="greenfish"></img>
                                        </div>
                                        <div class="flex-one" style="text-align: left;position: relative;">
                                            <div class="position_center">
                                                <div class="brandcover">
                                                    <div class="band" v-html="val.brand" :style="{lineHeight: val.id=='nJTEcv-p9EwhKu3ctCE3dQ'?'23px':'31px'}"></div>
                                                    <div style="height: 26px;" v-if="val.brand == 'FRESH 馥蕾诗'"></div>
                                                </div>
                                                <div class="title" >{{val.title}}</div>
                                                <div class="flex-container justify-content_flex-justify align-items_flex-end" style="padding-right: 24px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：{{val.address}}</div>
                                                    <div class="detail-tips">{{val.tips}}</div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="padding-top: 16px;box-sizing: border-box;">
                        <div>
                            <div style="margin-top:0px">
                                <img src="https://p1.fishqc.net/FowSoTJQU25--TSFP0cX90wIMJR6" alt="">
                            </div>
                            <div style="margin-top:-28px;">
                                <div class="double11P3_desc1">双十一囤货计划中的儿童用品更需要精挑细选，经过科学测评，</div>  
                                <div class="double11P3_desc1">选择绿鱼优品才放心。</div>    
                            </div>
                        </div>
                        <div class="munbox" :style="{marginTop: index3==0?'24px':'24px'}"  v-for="(item,index3) in productdata2">
                            <div class="producttype">{{item.tap}}</div>
                            <!-- <div class="dec">{{item.dec}}</div> -->

                            <div class="dec-text">{{item.destext}}
                               <!--  <div class="tips">
                                    <div  class="tipstext">{{item.dec}}</div>
                                </div> -->
                            </div>
                            <div>
                                <div class="productdetailcontain" v-for="(val,index) in item.product" @click="toproductdetail(val.type,val.id)">
                                    <div class="flex-container" style="height: 100%">
                                        <div class="imgcontain">
                                            <img :src="val.img" :class="[val.class,'center']">
                                            <img src="https://try.fishqc.com/img/addGreenFish.png"  style="width:65px;" class="greenfish" v-if="val.id !== 'Oenw-8ZJEpUMpmz5Sg5qUQ'"></img>
                                        </div>
                                        <div class="flex-one" style="text-align: left;position: relative;">
                                            <div class="position_center">
                                                <div class="brandcover">
                                                    <div class="band" v-html="val.brand"></div>
                                                    <div style="height: 26px;" v-if="val.brand == 'FRESH 馥蕾诗'"></div>
                                                </div>
                                                <div class="title" :style="{paddingBottom: val.id=='Oenw-8ZJEpUMpmz5Sg5qUQ'?'6px':'18px'}">{{val.title}}</div>
                                                <div v-if="val.id == 'Oenw-8ZJEpUMpmz5Sg5qUQ'">
                                                    <img src="https://p1.fishqc.net/FnUDkSVsgSVkNP6okNzaUL6Jl6kt">
                                                </div>
                                                <div class="flex-container justify-content_flex-justify align-items_flex-end" style="padding-right: 24px;box-sizing: border-box;">
                                                    <div class="address">品牌所在地：{{val.address}}</div>
                                                    <div class="detail-tips">{{val.tips}}</div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div class="techcontain">
                    <div>
                        <img src="https://p1.fishqc.net/Fvm20B-b4qoqU6-OO0YoJDdX27d3" alt="">
                    </div>
                    <img src="https://p1.fishqc.net/FmNkncVFZswE8JCRFo6B1OZ0SiN9" style="width: 100%;">
                    <div style="padding-top:150px;text-align: center;box-sizing: border-box;">
                        <img src="https://p1.fishqc.net/FoKKuNu-4IDZN5wyr0BkAttV5-7T" >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.about_menu_top {
    margin: 100px auto 0;

}
.fangyicontain{
    font-size: 0;
}

.mumcontain{
    width: 1000px;
    margin:0 auto;
    display: block;
    text-align: center;
    /*padding-top: 865px;*/
    
}
.muntitle{
    font-size:32px;
    font-family:Songti SC;
    font-weight:900;
    color:rgba(255,255,255,1);
    line-height:43px;
    text-shadow:0px 3px 8px rgba(61,186,173,0.9);
    padding:0 20px;
    vertical-align: middle;
}

.verticalalign-middle{
    vertical-align: middle;
}

.munbox{
    width:100%;
    
    
    background: #FFD1AB;
    border-radius:24px;
    padding:0 32px 29px;
    margin-top: 50px;
    box-sizing: border-box;

}

.munbox .munbox1{
    margin-top: 40px;
}
.producttype{
    display:inline-block;
    width:177px;
    height:46px;
    font-family: 'Source Han Serif CN';
    /*padding-top: 7px;*/
    box-sizing: border-box;
    line-height: 46px;
    color:#fff;
    font-size:30px;
    text-align:center;
    border-bottom-left-radius:36px;
    border-bottom-right-radius:36px;
    /*background: linear-gradient(0deg, #A9A0FF, #8360DB);*/
    background: -webkit-linear-gradient(top, #FFA266, #FB7E2E);
    background: -o-linear-gradient(top, #FFA266, #FB7E2E);
    background: -moz-linear-gradient(top, #FFA266, #FB7E2E);
    background: -ms-linear-gradient(top, #FFA266, #FB7E2E);
    background: -webkit-gradient(linear, 0% 100%, from(#FFA266), to(#FB7E2E));
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#FFA266), color-stop(100%,#FB7E2E));
    /*box-shadow: 0px 0px  8px #39b0a3;*/
}

.gradient{
    background: #000000;
    background: -moz-linear-gradient(top,  #000000 0%, #ffffff 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#000000), color-stop(100%,#ffffff));
    background: -webkit-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: -o-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: -ms-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: linear-gradient(to bottom,  #000000 0%,#ffffff 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#ffffff',GradientType=0 );
}
.dec{
    padding:10px 32px 18px;
    box-sizing:border-box;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(80,79,75,1);
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #6E65C5;
    line-height: 36px;
}

.dec-text{
    /*font-size:18px;
    color:#494947;*/
    /*line-height:30px;*/
    /*text-indent:3px;*/
    text-align:left;
    /*padding:20px 32px;*/
    background-color:#fff;
    border-radius:16px;

    position:relative;
    margin-bottom: 30px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 500;
   color: #F97723;
    line-height: 36px;
    padding:10px 32px 18px;
    box-sizing:border-box;
    margin-top: 30px;
    
}
.tips{
    /*width: 174px;*/
    height:36px;
    line-height:36px;
    background-color:#45ccbe;
    box-sizing:border-box;
    position:absolute;
    bottom:-12px;
    right:0;
    border-bottom-right-radius:20px;
    border-top-left-radius:20px;
    text-align: center;
    background: linear-gradient(180deg, #A79EFE, #867EDD);
    padding:0 20px;
    box-sizing: border-box;
    
}
.tipstext{
    display:inline-block;
    font-size:22px;
    font-family: Source Han Sans CN;
    font-weight:400;
    color:#fff;
    line-height: 36px;
}

.productdetailcontain{
    width: 456px;
    margin-right: 22px;
    display: inline-block;
    background-color: #fff;
    border-radius:24px;
    height: 160px;
    vertical-align: top;
    margin-bottom:14px;
    cursor: pointer;

}
.flex-container{
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
}

.productdetailcontain:nth-of-type(2n){
    margin-right: 0px;
}

.imgcontain{
    width: 154px;
    height: 100%;
    display: inline-block;
    text-align:center;
    position: relative;
}
.center{
    position:absolute;
    left:50%;
    top:50%;
    transform: translate(-50%, -50%);
}
.greenfish{
    position:absolute;
    left:4px;
    bottom:8px;
}
.class1{
    width:115px;
    height:133px;
}
.class2{
    width:49px;
    height:126px;
}
.class3{
    width:113px;
    height:138px;
}
.class4{
    width:113px;
    height:151px;
}
.class5{
    width:125px;
    height:135px;
}
.class6{
    width:129px;
    height:135px;
}
.class7{
    width:148px;
    height:140px;
}
.class8{
    width:79px;
    height:134px;
}
.class9{
    width:122px;
    height:142px;
}
.class10{
    width:127px;
    height:146px;
}

.class11{
    width:115px;
    height:138px;
}
.class12{
    width:81px;
    height:114px;
}
.class13{
    width:109px;
    height:138px;
}
.class14{
    width:71px;
    height:132px;
}
.class15{
    width:104px;
    height:126px;
}
.class16{
    width:108px;
    height:134px;
}

.class17{
    width:43px;
    height:128px;
}
.class18{
    width:106px;
    height:139px;
}
.class19{
    width:46px;
    height:120px;
}
.class20{
    width:54px;
    height:122px;
}

.flex-one{
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}
.brandcover{
    padding:0px 0 0px;
}

.band{
    
    font-size:24px;
    line-height: 26px;
    font-family:PingFang SC;
    font-weight:500;
    color: #6E65C5;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
   
    color: #F97723;
    line-height: 31px;
}

.title{
    font-size:18px;
    line-height: 18px;
    font-family:PingFang SC;
    font-weight:400;
    color: #6E65C5;
    padding-bottom: 18px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #F97723;
    line-height: 31px;
}

.detail-tips{
    padding:5px 12px 5px 14px;
    /*height:30px;*/
    background: #FBA74D;
    border-radius:12px 0px 12px 0px;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:400;
    
    color: #FEFEFE;
    line-height:16px;
    display:inline-block;
    text-align: center;
    opacity: 0.7;
   /* position: absolute;
    right: 25px;
    bottom:32px;*/
    vertical-align: bottom;

}
.address{
    /*padding-top: 16px;*/
    font-size:16px;
    line-height: 16px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(121,121,121,1);
    font-size: 17px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    
    color: #F97723;
    line-height: 18px;
    vertical-align: bottom;
}

.techcontain{
    padding-top: 40px;
    box-sizing: border-box;
    width: 1042px;
    margin:0 auto;
    display: block;
    text-align: center;
}
.double11P3_desctitle{
    font-size: 36px;
    font-family: Source Han Serif CN;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    padding-bottom: 22px;
    box-sizing: border-box;

}

.double11P3_desc1{
    width: 856px;
    font-size: 26px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 46px;
    margin:0 auto;
}

.position_center{
    position: absolute;
    top:50%;
    transform: translate(0,-50%);
    width: 100%;
}

.justify-content_flex-justify{
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}
.align-items_flex-end{
    -webkit-box-align: end;
    -ms-flex-align: end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
export default {
    name: 'about',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            productdata:[
            {
                tap:'精华',
                dec:'剁手必囤好物',
                destext:'精华液中富含多种功效成分且浓度较高，是护肤routine中重要一环，选购时要看功效，更要看安全。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/FrR6dgsDvipIaLisS6arytBEoxqn',
                    class:'class1',
                    brand:'PURID 先妍净肤精华液',
                    title:'',
                    tips:'净透毛孔',
                    address:'中国',
                    type:'cosmetic',
                    id:'_dwf5H2duk1spkK_iJXzOQ',
                    position:'left',
                    width:"width1",
                    title_width:'title_width1',
                    munbox1:'munbox1'

                },{
                    img:'https://p1.fishqc.net/FoeXIzBRWQfQoMeU_VNlu_Hzqby4',
                    class:'class2',
                    brand:'Easyface艺霏',
                    title:'艺霏虾青素蓓润修护精华液',
                    tips:'修氧双效',
                    address:'中国',
                    type:'cosmetic',
                    id:'utwvec62MvvNqq3EaZnpwg',
                    position:'left',
                    width:"width2",
                    title_width:'title_width2'

                },{
                    img:'https://p1.fishqc.net/FvW6Rm8KOWEKXSh3rdCzH74w3a-2',
                    class:'class3',
                    brand:'SKINCEUTICALS修丽可',
                    title:'植萃舒缓亮妍精华露',
                    tips:'舒缓褪红',
                    address:'美国',
                    type:'cosmetic',
                    id:'DdB7MXBnpsfWJUxHJ23liQ',
                    position:'left',
                    width:"width2",
                    title_width:'title_width2'

                },{
                    img:'https://p1.fishqc.net/Fnlth-cTSdKiOvrcG2-opK8z706V',
                    class:'class4',
                    brand:'LANEIGE兰芝',
                    title:'新水酷高保湿精华露（清润）',
                    tips:'干皮挚爱',
                    address:'韩国',
                    type:'cosmetic',
                    id:'WpTRkHcsA8btsbOWZMoP_w',
                    position:'left',
                    width:"width2",
                    title_width:'title_width2'

                }]
            },
            {
                tap:'爽肤水',
                dec:'打造迷人眼眸',
                destext:'爽肤水可再次清洁以恢复肌肤表面的酸碱值，又能让角质层充分浸润，加速后续护肤品的吸收，安全的绿鱼爽肤水必不可少。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/FmQ_6XU-ilUGAOpMemO9wQ3MvwVd',
                    class:'class5',
                    brand:'My Clorisland 花皙蔻',
                    title:'洛神花细致毛孔精华水',
                    tips:'混油皮必备',
                    address:'中国',
                    type:'cosmetic',
                    id:'BgdaLLepToHrcHu00hNxTg',
                    position:'right',
                    width:"width3",
                    title_width:'title_width3'
                },{
                    img:'https://p1.fishqc.net/FuHqJgiPfawIzrOJy1pgTOFrF274',
                    class:'class6',
                    brand:'IPSA茵芙莎',
                    title:'流金岁月凝润美肤水',
                    tips:'保湿净透',
                    address:'日本',
                    type:'cosmetic',
                    id:'MJuXaYg7_IxfTpA-NDtfEA',
                    position:'right',
                    width:"width4",
                    title_width:'title_width4'

                }]
            },
            {
                tap:'面霜',
                dec:'助力护肤吸收',
                destext:'秋燥冬寒，肌肤容易有小情绪，面霜相较乳液滋润性更强，安全面霜可以补充及锁住水份，肌肤和心情都更愉悦。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/Fitn3BzvMXjSYuJkKXawsaoxwXHV',
                    class:'class5',
                    brand:'Clé de Peau Beauté肌肤之钥',
                    title:'金致乳霜',
                    tips:'滋养弹润',
                    address:'日本',
                    type:'cosmetic',
                    id:'pvSTCcpvKrUdcPkn_4SYnA',
                    position:'left',
                    width:"width5",
                    title_width:'title_width5'
                },{
                    img:'https://p1.fishqc.net/Fhpu36L40b3XzDnBnAJBgspu2bLe',
                    class:'class6',
                    brand:'CLARINS娇韵诗',
                    title:'恒润奇肌保湿凝露',
                    tips:'多层补水',
                    address:'法国',
                    type:'cosmetic',
                    id:'SbH7diI6AIqcvxsQdIK4eQ',
                    position:'left',
                    width:"width6",
                    title_width:'title_width6'
                }]
            },
            

        ],
        productdata1:[
            {
                tap:'身体护理',
                dec:'营造天生好皮肤',
                destext:'身体肌肤皮脂腺较少，油脂分泌也比较少，容易干燥，在秋冬更需要安全的绿鱼身体护理，补充和锁住水分。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/Fp8vPFPsQ1z069bBRmqV1MECcLTY',
                    class:'class7',
                    brand:'BATHFEEL浴见',
                    title:'甄润身体按摩精华油',
                    tips:'以油养肤',
                    address:'中国',
                    type:'cosmetic',
                    id:'81YNRbj7Uhv9BQ0kRoo6pQ',
                    position:'left',
                    width:"width9",
                    title_width:'title_width9',
                    munbox1:'munbox1'

                },{
                    img:'https://p1.fishqc.net/FgK74kuw_Gi76mhoqq30wjNlh0MZ',
                    class:'class8',
                    brand:'NIVEA妮维雅',
                    title:'精华油润肤露 - 樱花香气',
                    tips:'轻薄温润',
                    address:'德国',
                    type:'cosmetic',
                    id:'mMZFtafUdgvl4RmhzfP3xw',
                    position:'left',
                    width:"width10",
                    title_width:'title_width10'

                }]
            },
            {
                tap:'漱口水',
                dec:'一秒提亮气色',
                destext:'使用漱口水清洁口腔保持口气清新越来越流行了，但劣质漱口水对口腔内部造成损伤和破坏，选购更要谨慎。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/FiIdxxmluYyUJQsyPsPzhrKZMIY_',
                    class:'class9',
                    brand:'日本Propolinse',
                    // brand1:'阿玛尼「传奇红管」 臻致丝绒哑光唇釉',
                    title:'比那氏蜂胶漱口水（粉色樱花）',
                    tips:'温和清新',
                    address:'日本',
                    type:'cosmetic',
                    id:'6LP05b76GMike0EP97Zasw',
                    position:'right',
                    width:"width11",
                    title_width:'title_width11'
                },{
                    img:'https://p1.fishqc.net/FjoR13fIuaSF1gxBvV1yhJw0e9Z4',
                    class:'class10',
                    brand:'舒客',
                    title:'双效鲜活漱口水 （满杯红柚）',
                    tips:'沁爽口感',
                    address:'中国',
                    type:'cosmetic',
                    id:'iiX1hiN_licjW4nOlPd0Ew',
                    position:'right',
                    width:"width12",
                    title_width:'title_width12'

                }]
            },
            {
                tap:'保健品',
                dec:'一秒提亮气色',
                destext:'人体所需营养素从三餐不足以完全提供到位，还需额外补充身体缺失营养元素。想要健康有保障，跟着小鱼榜单选。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/Ft4uTt7mcmmjvnJcQUK-H9H0qrL2',
                    class:'class11',
                    brand:'SWISSE ULTIBOOST',
                    // brand1:'阿玛尼「传奇红管」 臻致丝绒哑光唇釉',
                    title:'无腥味野生鱼油',
                    tips:'呵护健康',
                    address:'澳大利亚',
                    type:'food',
                    id:'MHyOQg1J2NFlohf7kP2goQ',
                    position:'right',
                    width:"width11",
                    title_width:'title_width11'
                },{
                    img:'https://p1.fishqc.net/Fpqdd1o0rtNvt7JKrdQX92QGLP4n',
                    class:'class12',
                    brand:'GNC健安喜',
                    title:'高含量钙片1000mg',
                    tips:'富含高钙',
                    address:'美国',
                    type:'food',
                    id:'yIO8Zliupd7oMIl6hXA_yg',
                    position:'right',
                    width:"width12",
                    title_width:'title_width12'

                }]
            }
            

        ],
        productdata2:[
            {
                tap:'儿童洗浴',
                dec:'呵护宝宝嫩滑脸蛋',
                destext:'宝宝肌肤娇嫩，洗发沐浴用品除了温和清洁，更要低敏呵护，成分安全，认准安全优品，保护宝宝肌肤健康。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/FmgjQfcdu--8EG-9dBUV69NIMwpv',
                    class:'class13',
                    brand:'PIGEON贝亲',
                    title:'婴儿洗发沐浴泡沫 (含桃叶精华)',
                    tips:'安心洗护',
                    address:'日本',
                    type:'cosmetic',
                    id:'nHfjVKorSgwT2n1zKRkNjw',
                    position:'left',
                    width:"width13",
                    title_width:'title_width13',
                    // effency:'舒缓、保湿、温和无刺激功效显著',
                    munbox1:'munbox1'

                },{
                    img:'https://p1.fishqc.net/FmyleZS59o0Z1stQFh2l9zvx6C7E',
                    class:'class14',
                    brand:'Arau亲皙',
                    title:'婴儿 2合1沐浴洗发泡泡',
                    tips:'洗浴合一',
                    address:'日本',
                    type:'cosmetic',
                    id:'Q0AhQZQGY-F7G6KVvYG2Aw',
                    position:'left',
                    width:"width14",
                    title_width:'title_width14'


                }]
            },
            {
                tap:'儿童牙膏',
                dec:'保护宝宝肌肤健康',
                destext:'儿童牙釉质稚嫩及口腔黏膜敏感，容易吞咽牙膏，劣质儿童牙膏更是有致敏、致癌物质，选择安全优品至关重要。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/FmE6BIXKJyotGcpvyQbYG8DtLc6o',
                    class:'class15',
                    brand:'CHICCO智高',
                    title:'苹果香蕉味牙膏',
                    tips:'防蛀护牙',
                    address:'意大利',
                    type:'cosmetic',
                    id:'4PjfYYSMyzsOeDmVK65zlA',
                    position:'right',
                    width:"width15",
                    title_width:'title_width15'
                },{
                    img:'https://p1.fishqc.net/FpbOycTDAl_-_aO1gRu3YRbVWZnC',
                    class:'class16',
                    brand:'ORAJEL欧乐',
                    title:'婴幼儿无氟可吞咽学习牙膏',
                    tips:'柔软清新',
                    address:'美国',
                    type:'cosmetic',
                    id:'JkeNqehZyOA3Gyg8mxNOFA',
                    position:'right',
                    width:"width16",
                    title_width:'title_width16'

                }]
            },
            {
                tap:'儿童面霜 ',
                dec:'保护宝宝肌肤健康',
                destext:'劣质面霜导致肌肤角质层受损，出红血丝，起皮，甚至过敏，严重的还会成大头娃娃影响发育，呵护宝宝选择绿鱼优品。',
                destext1:'',
                product:[
                {
                    img:'https://p1.fishqc.net/FnF9YOYju6Y686-cRiSvDSp7EIMk',
                    class:'class17',
                    brand:'AVEENO艾惟诺',
                    title:'婴儿舒缓滋养护肤霜',
                    tips:'缓解敏肌',
                    address:'美国',
                    type:'cosmetic',
                    id:'xeKFPU-cmMghz5jHElQn6g',
                    position:'right',
                    width:"width15",
                    title_width:'title_width15'
                },{
                    img:'https://p1.fishqc.net/FjMFnrt7ukAbUwH4hh5tpLL3Y6V8',
                    class:'class18',
                    brand:'PORORO啵乐乐',
                    title:'保湿润肤霜',
                    tips:'多效防护',
                    address:'韩国',
                    type:'cosmetic',
                    id:'ZmmwoVPvrJV6d7zet7xUAQ',
                    position:'right',
                    width:"width16",
                    title_width:'title_width16'

                }]
            }
            

        ],
      
        imgarr:['https://product.fishqc.com/img/activity/618/tech.png','https://product.fishqc.com/img/activity/618/tech-white.png','https://product.fishqc.com/img/activity/618/tech-kangyang.png'],
        }

    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        }
    },
    mounted() {
        // var position  =  this.$route.query.position
        // this.scrollTo(position)
        this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
    },
    methods: {
        scrollTo(position) {
            var that = this;
            var scroll_H;
            this.$nextTick(function() {
                if (position == 'greenrank') {
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                } else {
                    scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
                }
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
        toproductdetail(type,prdid){
            this.$router.push({
                path: '/product/'+type+'/'+prdid
            })
            
        }
    }
}
</script>